import PropTypes from 'prop-types';

import { Text } from '@bevy/bevy-design-system';
import { ErrorIcon } from '@bevy/bevy-design-system/deprecated';

import styles from './styles.module.less';

export default function GenericPageMessage({
  message,
  icon = <ErrorIcon />,
}) {
  return (
    <div role='note' className={styles.messageWrapper}>
      {icon}
      <Text variant='body1' align='center'>
        {message}
      </Text>
    </div>
  );
}

GenericPageMessage.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.node,
};
